var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.keyboardContainer },
    [
      _c(
        "div",
        { class: _vm.$style.flexContainer },
        [
          _vm._l(_vm.symbolsBeforeBackspace, function(value) {
            return _c(
              "v-btn",
              {
                key: value,
                class: _vm.$style.symbolButton,
                attrs: { disabled: _vm.disabled },
                on: {
                  click: function($event) {
                    return _vm.addSymbol(value)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(value) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              class: _vm.$style.symbolButton,
              attrs: { disabled: _vm.disabled },
              on: { click: _vm.removeSymbol }
            },
            [_c("i", { staticClass: "material-icons" }, [_vm._v("backspace")])]
          ),
          _vm._v(" "),
          _vm._l(_vm.symbolsAfterBackspace, function(value) {
            return _c(
              "v-btn",
              {
                key: value,
                class: _vm.$style.symbolButton,
                attrs: { disabled: _vm.disabled },
                on: {
                  click: function($event) {
                    return _vm.addSymbol(value)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(value) + "\n    ")]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("v-btn", {
        class: _vm.$style.spaceButton,
        attrs: { disabled: _vm.disabled },
        on: { click: _vm.addSpace }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/Keyboard.vue?vue&type=template&id=f787f214&
// module id = null
// module chunks = 